import MOCKED_SELF from "./settings/self";

export const MOCKED_SETTINGS_STATE = {
  self: MOCKED_SELF
};
